import React, { useEffect } from "react";
import MainTheme from "./themes/main-theme";
import { homeRoute } from "./routes/routesPath";
import { handleApiRequest } from "./services/handleApiRequest";
import { reportCrashError } from "./redux/common/thunk";

export default function ErrorFallback({ error }) {
  useEffect(() => {
    (async () => {
      if (process.env.REACT_APP_ENV_TYPE === "development") return;

      const request = {
        page: window.location.href,
        description: error?.message || error?.toString(),
      };

      await handleApiRequest(reportCrashError, request);
    })();
  }, [error]);

  return (
    <MainTheme renderChildren={true}>
      <div className="align-items-center d-flex flex-column flex-grow-1 justify-content-center text-center my-5">
        <img
          src="/images/error.webp"
          alt="Something went wrong"
          className="img-fluid"
          style={{ maxWidth: 250 }}
        />
        {/* <h5 className="mb-0 mt-3">Something went wrong!</h5> */}
        <h5 className="text-color my-3" style={{ letterSpacing: 1 }}>
          😣 I don't like it
        </h5>
        <p style={{ maxWidth: 500 }}>
          <b>Thankyou!</b> We have received the report and trying to fix it as soon as possible.
          Until then you can explore other things
        </p>
        <div className="hstack justify-content-center gap-2 align-items-center">
          <button
            className="primaryBtn px-3 py-1 rounded-2"
            onClick={() => window.location.reload()}>
            Retry
          </button>
          <button
            className="primaryBtn px-3 py-1 rounded-2"
            onClick={() => (window.location.href = homeRoute)}>
            Go to Home
          </button>
        </div>
      </div>
    </MainTheme>
  );
}
